export default "/images/gitlab.svg?6c274a89c888c9e2ecc3645c0cc93f86";